import { render } from "./ShoppingGuide.vue?vue&type=template&id=191556cb&scoped=true"
import script from "./ShoppingGuide.vue?vue&type=script&lang=js"
export * from "./ShoppingGuide.vue?vue&type=script&lang=js"

import "./ShoppingGuide.vue?vue&type=style&index=0&id=191556cb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191556cb"]])

export default __exports__